module.exports = __webpack_public_path__ + "img/KR.b026a630.png";